module.exports = __webpack_public_path__ + "img/mt_x.64e7b464.jpg";